import Vue from "vue";
import "@/assets/style/app.styl";
import colors from "vuetify/es5/util/colors";
import "@mdi/font/css/materialdesignicons.css";
// Your own translation file
import en from "vuetify/es5/locale/en";
import Vuetify, { VTextField, VTextarea } from "vuetify/lib";

Vue.use(Vuetify, {
  components: {
    VTextField,
    VTextarea
  },
  iconfont: "mdi",
  theme: {
    primary: "08c",
    info: "7D85F3",
    btn_color: "08c",
    secondary: "08c",
    accent: "C0CA33",
    discord_light: "99aab5",
    warning: colors.amber.base,
    error: colors.deepOrange.accent4,
    Certified: "4CAF50",
    Pending: "FFC107", //"CFD8DC",
    Deferred: "fb275d",
    Qualified: "4CAF50",
    Reminded: colors.blueGrey.lighten3,
    Expired: colors.amber.lighten3,
    Q: "4CAF50",
    "Not-Qualified": "FFC107",
    NQ: "FFC107"
  },
  rtl: false,
  lang: {
    locales: {
      en
    },
    current: "en"
  }
});
